/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import {
  GETSUBSCRIPTION_HOMEPAGE_REQUEST,
  GETSUBSCRIPTION_HOMEPAGE_SUCCESS,
  GETSUBSCRIPTION_HOMEPAGE_FAILURE,
} from "./subscriptionTypes";

const initialState = {
  loading: false,
  subscriptionHomepage: [],
  error: "",
};

const subscriptionHomepageReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETSUBSCRIPTION_HOMEPAGE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETSUBSCRIPTION_HOMEPAGE_SUCCESS:
      return {
        loading: false,
        subscriptionHomepage: action.payload,
        error: "",
      };
    case GETSUBSCRIPTION_HOMEPAGE_FAILURE:
      return {
        loading: false,
        subscriptionHomepage: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export { subscriptionHomepageReducer };
